export enum ExportEnumFormat {
    StandardID = 'ID (standard)',
    NameOnly = 'Navn',
    IDWithExclamation = 'ID !Navn',
    IDWithName = 'ID (Navn)',
}

export const MapExportEnumFormatToDisplayName = new Map<ExportEnumFormat, string>([
    [ExportEnumFormat.StandardID, 'ID [standard]'],
    [ExportEnumFormat.NameOnly, 'Navn'],
    [ExportEnumFormat.IDWithExclamation, 'ID !Navn'],
    [ExportEnumFormat.IDWithName, 'ID (Navn)'],
]);
